import React from 'react'
import InputCustomStyles from './child/InputCustomStyles'

const FormValidationLayer = ({ isEditMode = false, societyId = null }) => {
    return (
        <div className="row gy-4">

            {/* InputCustomStyles */}
            <InputCustomStyles isEditMode={isEditMode} societyId={societyId} />

            {/* InputStatus */}
            {/* <InputStatus /> */}

        </div>

    )
}

export default FormValidationLayer